import React from 'react';

const faqs = [
  {
    id: 1,
    question: "What is Snappy Slides?",
    answer: "Snappy Slides is a simple and easy to use slideshow application that allows you to create slideshows with your locally stored images.",
  },
  {
    id: 2,
    question: "What are the differences between the plans?",
    answer: "Snappy is completely free and allows up to 50 images per folder with basic features. Snappy Plus is also free but requires an account and offers up to 1000 images per folder with customizable transition times and background colors.",
  },
  {
    id: 3,
    question: "Do I need to create an account to use Snappy Slides?",
    answer: "You can use Snappy without an account, which allows up to 50 images per folder. Creating an account gives you access to Snappy Plus features including customizable transition times, background colors, and up to 1000 images per folder.",
  },
  {
    id: 4,
    question: "How does Snappy Slides work?",
    answer: "Snappy Slides randomly shuffles your images and displays them in a slideshow from one or both of your selected folders. When two folders are selected a random image is selected from each folder and displayed in a slideshow.  This is a key feature of Snappy Slides as you might want to share a slideshow with a friend or family member.",
  },
  {
    id: 5,
    question: "Do you store my images?",
    answer: "No, we do not store your images. All images are stored locally on your device. At no time do we store your images on our servers or any metadata about your images.",
  },
  {
    id: 6,
    question: "Why does it keep asking me to reindex my images when I browser away from the Slideshowpage?",
    answer: "Browser security prevents us from accessing your local folders without your permission. Privacy is our top priority and we do not store your images on our servers or any metadata about your images. Indexing only takes a few seconds.",
  },
  {
    id: 7,
    question: "When I choose a folder or click Reindex, a dialog box appears saying 'This will upload your images from your folder to this site'.",
    answer: "This is not actually happening and is only indexing the images locally on your device.  The dialog box is a browser message we cannot control.",
  },
  {
    id: 8,
    question: "Why do you need to select multiple folders?",
    answer: "This was one of the key features of Snappy Slides. To save you the hassle of moving images around, we allow you to select multiple folders and create a slideshow from them.",
  },
  {
    id: 9,
    question: "Is Snappy Slides really free?",
    answer: "Yes, Snappy Slides is completely free to use. Snappy plan is available to everyone without any account required. Snappy Plus features are also free but require creating an account to access them.",
  },
  {
    id: 10,
    question: "What types of images are supported?",
    answer: "Snappy Slides supports all common image formats including JPG, PNG, and GIF. We recommend using high-quality images for the best results.",
  },
];

export default function FAQ() {
  return (
    <div className="bg-white">
      <div className="mx-auto max-w-7xl px-6 py-24 sm:py-32 lg:px-8 lg:py-40">
        <h2 className="text-4xl font-semibold tracking-tight text-gray-900 sm:text-5xl">Frequently asked questions</h2>
        <dl className="mt-20 divide-y divide-gray-900/10">
          {faqs.map((faq) => (
            <div key={faq.id} className="py-8 first:pt-0 last:pb-0 lg:grid lg:grid-cols-12 lg:gap-8">
              <dt className="text-base/7 font-semibold text-primary lg:col-span-5">{faq.question}</dt>
              <dd className="mt-4 lg:col-span-7 lg:mt-0">
                <p className="text-base/7 text-gray-600">{faq.answer}</p>
              </dd>
            </div>
          ))}
        </dl>
      </div>
    </div>
  );
} 